import { styled } from 'goober';

const ValueGroup = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Input = styled('input')`
  flex: 1;
  width: 100%;
  padding: 6px 10px;
  border: 1px solid var(--input-border);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  background: white;
  transition: all 0.2s ease;
  &:focus {
    outline: none;
    border-color: var(--input-focus);
    box-shadow: 0 0 0 3px rgba(22, 160, 133, 0.1);
  }
  &:hover:not(:focus) {
    border-color: var(--text-muted);
  }
`;

const Unit = styled('span')`
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  min-width: 40px;
`;

interface ValueInputProps {
  value: number;
  unit: string;
  onChange: (value: number) => void;
}

export function ValueInput({ value, unit, onChange }: ValueInputProps) {
  const handleChange = (event: Event) => {
    const newValue = parseInt((event.target as HTMLInputElement).value, 10) || value;
    onChange(newValue);
  };

  return (
    <ValueGroup data-testid="iso-value-group">
      <Input
        type="number"
        id="iso-value"
        data-testid="iso-value"
        value={value}
        min="1"
        max="120"
        onChange={handleChange}
      />
      <Unit id="iso-value-unit">{unit}</Unit>
    </ValueGroup>
  );
}
